"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "parseDocumentFromString", {
  enumerable: true,
  get: function get() {
    return _parseDocumentFromString.default;
  }
});
Object.defineProperty(exports, "serializeDocumentIntoString", {
  enumerable: true,
  get: function get() {
    return _serializeDocumentIntoString.default;
  }
});
var _parseDocumentFromString = _interopRequireDefault(require("./Utils/parseDocumentFromString"));
var _serializeDocumentIntoString = _interopRequireDefault(require("./Utils/serializeDocumentIntoString"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfcGFyc2VEb2N1bWVudEZyb21TdHJpbmciLCJfaW50ZXJvcFJlcXVpcmVEZWZhdWx0IiwicmVxdWlyZSIsIl9zZXJpYWxpemVEb2N1bWVudEludG9TdHJpbmciLCJvYmoiLCJfX2VzTW9kdWxlIiwiZGVmYXVsdCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vc3JjL2ludGVybmFsLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBwYXJzZURvY3VtZW50RnJvbVN0cmluZyBmcm9tICcuL1V0aWxzL3BhcnNlRG9jdW1lbnRGcm9tU3RyaW5nJztcbmltcG9ydCBzZXJpYWxpemVEb2N1bWVudEludG9TdHJpbmcgZnJvbSAnLi9VdGlscy9zZXJpYWxpemVEb2N1bWVudEludG9TdHJpbmcnO1xuXG5leHBvcnQgeyBwYXJzZURvY3VtZW50RnJvbVN0cmluZywgc2VyaWFsaXplRG9jdW1lbnRJbnRvU3RyaW5nIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEsd0JBQUEsR0FBQUMsc0JBQUEsQ0FBQUMsT0FBQTtBQUNBLElBQUFDLDRCQUFBLEdBQUFGLHNCQUFBLENBQUFDLE9BQUE7QUFBOEUsU0FBQUQsdUJBQUFHLEdBQUEsV0FBQUEsR0FBQSxJQUFBQSxHQUFBLENBQUFDLFVBQUEsR0FBQUQsR0FBQSxLQUFBRSxPQUFBLEVBQUFGLEdBQUEifQ==